"use strict";
// this is UI logic. I will refactor the onchange to not require this.
Object.defineProperty(exports, "__esModule", { value: true });
exports.pluralize = void 0;
const pluralize = ({ amount, text }) => {
    if (parseInt(amount.toString(), 10) === 1) {
        return text;
    }
    return `${text}s`;
};
exports.pluralize = pluralize;
//# sourceMappingURL=pluralize.js.map